import PublicHeader from "@/components/PublicHeader";

export default function Mentions() {
    return (
        <div className="min-h-screen">
            <PublicHeader />
            <article className="max-w-3xl mx-auto pt-32 pb-24 px-6 sm:px-8">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B] mb-3">Document légal</p>
                <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-[#1D1D1F]">
                    Mentions légales
                </h1>
                <p className="mt-3 text-sm text-[#86868B]">Conformément à la LCEN (Loi n° 2004-575)</p>

                <Section title="Éditeur">
                    <p>
                        <strong>Ticketify SAS</strong><br />
                        Société par actions simplifiée<br />
                        Siège social&nbsp;: 12 rue de la Numérisation, 75001 Paris<br />
                        RCS Paris — n° SIREN&nbsp;: 105&nbsp;455&nbsp;729<br />
                        SIRET&nbsp;: 105&nbsp;455&nbsp;729&nbsp;00019<br />
                        N° TVA intracommunautaire&nbsp;: FR50&nbsp;105455729<br />
                        Représentant légal&nbsp;: —
                    </p>
                </Section>

                <Section title="Contact">
                    <p>
                        Email&nbsp;:{" "}
                        <a href="mailto:contact@ticketify.fr" className="text-[#007AFF] hover:underline">
                            contact@ticketify.fr
                        </a>
                        <br />
                        Support&nbsp;:{" "}
                        <a href="mailto:support@ticketify.fr" className="text-[#007AFF] hover:underline">
                            support@ticketify.fr
                        </a>
                        <br />
                        DPO (RGPD)&nbsp;:{" "}
                        <a href="mailto:dpo@ticketify.fr" className="text-[#007AFF] hover:underline">
                            dpo@ticketify.fr
                        </a>
                    </p>
                </Section>

                <Section title="Directeur de la publication">
                    <p>—</p>
                </Section>

                <Section title="Hébergement">
                    <p>
                        Le site est hébergé en France par un prestataire conforme aux exigences HDS et ISO&nbsp;27001.
                    </p>
                </Section>

                <Section title="Propriété intellectuelle">
                    <p>
                        L&apos;ensemble des éléments composant le site (textes, graphismes, logos, code) est la
                        propriété exclusive de Ticketify SAS. Toute reproduction, représentation, modification ou
                        adaptation est interdite sans autorisation écrite préalable.
                    </p>
                </Section>

                <Section title="Liens externes">
                    <p>
                        Ticketify peut contenir des liens vers des sites tiers. Nous ne saurions être tenus
                        responsables du contenu de ces sites.
                    </p>
                </Section>

                <Section title="Médiation">
                    <p>
                        Conformément à l&apos;article L612-1 du Code de la consommation, le consommateur peut
                        recourir gratuitement à un médiateur de la consommation en cas de litige non résolu.
                    </p>
                </Section>

                <p className="mt-12 text-sm text-[#86868B] italic">
                    Les champs encore marqués « — » (capital social, représentant légal, directeur de la
                    publication) seront complétés dès finalisation des statuts de Ticketify SAS.
                </p>
            </article>
            <footer className="border-t border-black/5 py-10 px-6 sm:px-8 text-center text-sm text-[#86868B]">
                © 2026 Ticketify · <a href="/cgu" className="hover:text-[#1D1D1F]">CGU</a> ·{" "}
                <a href="/confidentialite" className="hover:text-[#1D1D1F]">Confidentialité</a>
            </footer>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-[#1D1D1F] mb-3">{title}</h2>
            <div className="space-y-3 text-[15px] leading-relaxed text-[#1D1D1F]/90">{children}</div>
        </section>
    );
}
